export const ACCESS_TOKEN = "@/cq_manager/auth_token"
export const REFRESH_TOKEN = "@/cq_manager/refresh_token"
export const USER_DATA = "@/cq_manager/user"
